(function () {
  var solutionPaths = [
    '/pages/schools-classrooms',
    '/pages/assistive-listening-system-for-clinics',
    '/pages/solution-theater',
    '/pages/community-senior-living-assistive-listening',
    '/pages/conference-assistive-listening-system',
    '/pages/guided-tour-museum-venucast',
    '/pages/wireless-audio-distribution-solutions',
    '/pages/sports-bar-audio-solution',
    '/pages/courtroom-assistive-listening-solutions',
    '/pages/gym-auracast-listening-solution',
    '/pages/overall-use-cases'
  ];
  var collectionPaths = [
    '/collections/assistive-listening-for-church',
    '/collections/auracast-transmitters-for-assistive-listening',
    '/collections/universal-auracast-receivers-for-assistive-listening',
    '/collections/auracast-headphones-for-assistive-listening',
    '/collections/complete-auracast-assistive-listening-systems',
    '/collections/wireless-multi-speaker-system',
    '/collections/non-auracast-kits',
    '/collections/accessories-for-auracast-assistive-listening-systems'
  ];
  var path = window.location.pathname.replace(/\/$/, '');
  var isSolutionPage = solutionPaths.indexOf(path) !== -1;
  var isCollectionPage = collectionPaths.indexOf(path) !== -1;

  if (solutionPaths.indexOf(path) === -1 && collectionPaths.indexOf(path) === -1) {
    return;
  }

  function distinctProductLinks(container) {
    var links = container.querySelectorAll('a[href*="/products/"]');
    var byPath = {};

    Array.prototype.forEach.call(links, function (link) {
      var url = new URL(link.href, window.location.origin);
      byPath[url.pathname] = link;
    });

    return Object.keys(byPath).map(function (key) {
      return byPath[key];
    });
  }

  function findCard(link) {
    var node = link.parentElement;

    while (node && node !== document.body) {
      if (
        node.matches(
          'article, .card, .product, .product-item, [class*="product-card"], [class*="__product"]'
        )
      ) {
        var links = distinctProductLinks(node);
        var hasMedia = node.querySelector('img, [role="img"]');
        if (links.length >= 1 && hasMedia) {
          return node;
        }
      }
      node = node.parentElement;
    }

    return null;
  }

  function findMedia(card) {
    var media = card.querySelector(
      '.card-product__wrapper > .card-media, [class*="product-media"][role="img"], [class*="__product-media"][role="img"]'
    );

    if (media) {
      return media;
    }

    var image = card.querySelector('img');
    if (!image) {
      return null;
    }

    if (image.parentElement && image.parentElement.tagName === 'PICTURE') {
      return image.parentElement;
    }

    return image;
  }

  function addMediaLinks() {
    var links = document.querySelectorAll('#MainContent a[href*="/products/"]');
    var handledCards = [];

    Array.prototype.forEach.call(links, function (productLink) {
      var card = findCard(productLink);
      if (!card || handledCards.indexOf(card) !== -1) {
        return;
      }
      handledCards.push(card);

      if (isCollectionPage || isSolutionPage) {
        card.setAttribute('data-venucast-product-card-url', productLink.href);
        card.style.cursor = 'pointer';
      }

      var media = findMedia(card);
      if (!media || media.closest('a[href*="/products/"]')) {
        return;
      }

      var mediaLink = document.createElement('a');
      var title = card.querySelector('h2, h3, h4, .card-title');
      mediaLink.className = 'venucast-product-media-link';
      mediaLink.href = productLink.href;
      mediaLink.setAttribute(
        'aria-label',
        title ? 'View ' + title.textContent.trim() : 'View product'
      );

      media.parentNode.insertBefore(mediaLink, media);
      mediaLink.appendChild(media);
    });
  }

  function addHeadphoneComparisonCardLink() {
    if (path !== '/collections/auracast-headphones-for-assistive-listening') {
      return;
    }

    var cards = document.querySelectorAll('.vc-hp-cro__choice-card');

    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-venucast-product-card-url') || !card.querySelector('img')) {
        return;
      }

      var cta = card.querySelector(':scope > a[href="#headphone-products"]');
      if (!cta) {
        return;
      }

      card.setAttribute('data-venucast-product-card-url', cta.href);
      card.style.cursor = 'pointer';
    });
  }

  function addCompleteSystemCardLinks() {
    if (path !== '/collections/complete-auracast-assistive-listening-systems') {
      return;
    }

    var cards = document.querySelectorAll('.vc-ak__kit');

    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-venucast-product-card-url') || !card.querySelector('img')) {
        return;
      }

      var primaryCta = card.querySelector('.vc-ak__text-link[href*="/products/"]');
      if (!primaryCta) {
        return;
      }

      card.setAttribute('data-venucast-product-card-url', primaryCta.href);
      card.style.cursor = 'pointer';
    });
  }

  function addNonAuracastComparisonCardLinks() {
    if (path !== '/collections/non-auracast-kits') {
      return;
    }

    var cards = document.querySelectorAll('.vc-nk-cro__choice-card');

    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-venucast-product-card-url') || !card.querySelector('img')) {
        return;
      }

      var cta = card.querySelector(':scope > a[href="#kit-products"]');
      if (!cta) {
        return;
      }

      card.setAttribute('data-venucast-product-card-url', cta.href);
      card.style.cursor = 'pointer';
    });
  }

  function addTheaterSolutionCardLinks() {
    if (path !== '/pages/solution-theater') {
      return;
    }

    var cards = document.querySelectorAll('.vc-theater-v4__solution-card');

    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-venucast-product-card-url') || !card.querySelector('img')) {
        return;
      }

      var primaryCta = card.querySelector('.vc-theater-v4__text-link[href]');
      if (!primaryCta) {
        return;
      }

      card.setAttribute('data-venucast-product-card-url', primaryCta.href);
      card.style.cursor = 'pointer';
    });
  }

  function addConferenceSolutionCardLinks() {
    if (path !== '/pages/conference-assistive-listening-system') {
      return;
    }

    var cards = document.querySelectorAll('.vc-conf__solution-card');

    Array.prototype.forEach.call(cards, function (card) {
      if (!card.querySelector('img')) {
        return;
      }

      var primaryCta = card.querySelector('.vc-conf__card-actions a[href]');
      if (!primaryCta) {
        return;
      }

      card.setAttribute('data-venucast-product-card-url', primaryCta.href);
      card.style.cursor = 'pointer';
    });
  }

  document.addEventListener('click', function (event) {
    if ((!isCollectionPage && !isSolutionPage) || event.defaultPrevented || event.button !== 0) {
      return;
    }

    var card = event.target.closest('[data-venucast-product-card-url]');
    if (!card || event.target.closest('a, button, input, select, textarea, label, form, summary, details, [role="button"]')) {
      return;
    }

    var productUrl = card.getAttribute('data-venucast-product-card-url');
    if (!productUrl) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(productUrl, '_blank', 'noopener');
      return;
    }

    window.location.assign(productUrl);
  });

  addMediaLinks();
  addHeadphoneComparisonCardLink();
  addCompleteSystemCardLinks();
  addNonAuracastComparisonCardLinks();
  addTheaterSolutionCardLinks();
  addConferenceSolutionCardLinks();

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) {
      return;
    }
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      addMediaLinks();
      addHeadphoneComparisonCardLink();
      addCompleteSystemCardLinks();
      addNonAuracastComparisonCardLinks();
      addTheaterSolutionCardLinks();
      addConferenceSolutionCardLinks();
    });
  });

  observer.observe(document.getElementById('MainContent'), {
    childList: true,
    subtree: true
  });
})();
